export const ArrivalMaterialTableFilterData = [
    {
        "idFromColumnFilter": "articleNumberSupplier",
        "id": "supplierMaterial",
        "field": "article",
    },
    {
        "idFromColumnFilter": "materialNameSupplier",
        "id": "supplierMaterial", "field": "materialNameSupplier",
    },
    {
        "idFromColumnFilter": "articleNumber",
        "id": "materialOrganizationOption", "field": "articleNumber",
    },
    {
        "idFromColumnFilter": "name",
        "id": "materialOrganizationOption", "field": "name",
    },
    {
        "idFromColumnFilter": "unit",
        "id": "materialOrganizationOption", "field": "unit", "field2": "name"
    },
    {
        "idFromColumnFilter": "quantity",
        "id": "quantity",
    },
    {
        "idFromColumnFilter": "amountInCurrencyArrival",
        "id": "amountInCurrencyArrival",
    },
    {
        "idFromColumnFilter": "priceInCurrencyArrival",
        "id": "materialPriceInCurrencyArrival", "field": "price",
    },
    {
        "idFromColumnFilter": "exchangeRateToBaseCurrencyBaseMaterials",
        "id": "exchangeRateToBaseCurrencyBaseMaterials",
    },
    {
        "idFromColumnFilter": "priceInCurrencyBase",
        "id": "materialPriceInCurrencyBase", "field": "price",
    },
    {
        "idFromColumnFilter": "exchangeRateToAlternativeCurrencyBaseMaterials",
        "id": "exchangeRateToAlternativeCurrencyBaseMaterials",
    },
    {
        "idFromColumnFilter": "priceInCurrencyAlternative",
        "id": "materialPriceInCurrencyAlternative", "field": "price",
    },
    {
        "idFromColumnFilter": "basePrice",
        "id": "supplierMaterial", "field": "basePrice",
        "filterFn": (value, filterValue, currencyMap) => {
            const displayValue = `${value.price?.toFixed(3)} ${currencyMap?.get(value.currencyId)?.curAbbreviation}`
            return displayValue.toString()?.toLowerCase().includes(filterValue?.toLowerCase())
        }
    },
    {
        "idFromColumnFilter": "realBasePrice",
        "id": "materialPriceInRealBasePrice",
        "filterFn": (value, filterValue, currencyMap) => {
            const displayValue = `${value.price?.toFixed(3)} ${currencyMap?.get(value.currencyId)?.curAbbreviation}`
            return displayValue.toString()?.toLowerCase().includes(filterValue?.toLowerCase())
        }
    },
    {
        "idFromColumnFilter": "priceIncreaseInBasePrice",
        "id": "priceIncreaseInBasePrice",
    },
    {
        "idFromColumnFilter": "exchangeRateToBasePrice",
        "id": "exchangeRateToBasePrice",
    },
    {
        "idFromColumnFilter": "coefficientCurrencyBasePrice",
        "id": "coefficientCurrencyBasePrice",
    },
    {
        "idFromColumnFilter": "losses",
        "id": "losses",
    },
    {
        "idFromColumnFilter": "length",
        "id": "length",
    },
    {
        "idFromColumnFilter": "width",
        "id": "width",
    },
]